"use strict";

exports.__esModule = true;
exports.Spinner = void 0;

var React = _interopRequireWildcard(require("react"));

var _styled = require("@manifest-ui/styled");

var _react2 = require("@emotion/react");

var _visuallyHidden = require("@manifest-ui/visually-hidden");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/spinner/src/Spinner.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const spin = (0, _react2.keyframes)({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});
const SpinnerRoot = (0, _styled.styled)('span', {
  label: 'Spinner',
  themeKey: 'spinner'
})({
  borderColor: 'currentColor',
  borderStyle: 'solid',
  borderRadius: '50%',
  borderTopColor: 'transparent',
  borderWidth: 'medium',
  color: 'primary.500',
  display: 'inline-block',
  animation: `${spin} .8s linear infinite`,
  height: 32,
  width: 32
});
const Spinner = React.forwardRef((props, ref) => {
  const {
    label,
    ...other
  } = props;
  return React.createElement(SpinnerRoot, _extends({
    ref: ref
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }), label && React.createElement(_visuallyHidden.VisuallyHidden, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 19
    }
  }, label));
});
exports.Spinner = Spinner;
Spinner.displayName = 'Spinner';